import { JSX } from 'react';
import { TodoTask } from '../../todolist/add-todo/addTodoList';
import {categoryOptions} from '../../todolist/category/category';
import CheckBox from '../../home-page/preview/checkBox/checkBox';
import TodoManager from '../../todolist/data/todoManager';
import TodoDate from '../../todolist/todoDate/date';
import './todoView.css';
import BinIcon from '../../assets/images/svgs/bin--Streamline-Pixel.svg';
import editIcon from '../../assets/images/svgs/pencil-edit.svg'

const TodoView = ({todo, onUpdate, openEdit}:{todo:TodoTask, onUpdate:() => void, openEdit:(todo: TodoTask) => void}): JSX.Element => {
    
    const changeComplete = async (isComplete: boolean) => {
        try {
            await todoManager.updateTodoComplete(todo, isComplete);
            onUpdate();
        } catch (error) {
            console.error('Failed to update todo:', error);
        }
    };

    const deleteTodo = async () => {
        try {
            await todoManager.deleteTodo(todo._id);
            onUpdate();
        } catch (error) {
            console.error('Failed to update todo:', error);
        }
    }

    const todoManager = TodoManager.getInstance();
    const changeTodoDate = async (date: Date) => {
        try {
            await todoManager.updateTodoDate(todo, date);
            onUpdate();
        } catch (error) {
            console.error('Failed to update todo:', error);
        }
    }

    return (
        <div className='todo-task-container'>
            <div className='todo-task-view'>
                <CheckBox isCompleted={todo.completed} onCompleteChange={changeComplete}/>
                <div className='todo-task-content-outter'>
                    <div className='todo-task-content'>
                        <p className={`todo-task-title ${todo.completed ? 'completed' : ''}`}>{todo.title}</p>
                        <div className='right-align-container'>
                            <img className='edit-icon' src={editIcon} onClick={() => openEdit(todo)}/>
                            <TodoDate dateFormat={'MMM dd'} date={todo.date} onTodoDateChange={(date: Date) => changeTodoDate(date)}/>
                            <img src={categoryOptions.find(option => option.type === todo.category).image} className='todo-task-category-img'/>
                        </div>
                    </div>
                    <div className="todoView-bottom-line"/>
                </div>
                <img src={BinIcon} className='todo-task-category-img' onClick={deleteTodo}/>
            </div>
        </div>
    ); 
};
  
export default TodoView;
